import { FRONTEND_ROOT } from "config/constants";

export default function generateReferralUrl(slug, referralCode) {
  return `${FRONTEND_ROOT}/referral/${slug}?code=${referralCode}`;
}
